import { events } from './events';

export const analyticsEventWhitelist = [
  events.SIGNED_UP,
  events.SIGNED_IN,
  events.ACCOUNT_DELETED,
  events.PASSWORD_VALIDATED,
  events.REFERRAL_MAGIC_LINK_CREATED,
  events.HELP_WIDGET,
  events.TEXT_CLUB_PHONE_SUBMITTED,

  // prospect registration
  events.PROSPECT_SAVED,
  events.PROSPECT_EMAIL_CHANGE_ERROR,
  events.PROSPECT_EMAIL_CHANGE,
  events.PROSPECT_COMPLETED_REGISTRATION,
  events.PROSPECT_COMPLETED_USERNAME,

  // orders
  events.CHECKOUT_STARTED,
  events.IAP_ORDER_STARTED,
  events.ORDER_COMPLETED,
  events.FIRST_PAID_ORDER,
  events.PAYMENT_ERROR,
  events.MEMBERSHIP_TRIAL_STARTED,
];
